(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

import React from 'react';
import ThemeProvider from "./ThemeProvider.js";
import contrast from "../../themes/contrast";
import light from "../../themes/light";
var themes = {
  contrast: contrast,
  light: light
};

var ConditionalWrapper = function ConditionalWrapper(props) {
  var condition = props.condition,
      wrapper = props.wrapper,
      children = props.children;
  return condition ? wrapper(children) : children;
};

var themeWrapper = function themeWrapper(WrappedComponent) {
  return function (props) {
    var themeId = props.themeId,
        rest = _objectWithoutProperties(props, ["themeId"]);

    return React.createElement(ConditionalWrapper, {
      condition: themeId,
      wrapper: function wrapper(children) {
        return React.createElement(ThemeProvider, {
          theme: themes[themeId]
        }, children);
      }
    }, React.createElement(WrappedComponent, rest));
  };
};

var _default = themeWrapper;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(themes, "themes", "/home/vsts/work/1/s/src/components/themes/themeWrapper.js");
  reactHotLoader.register(ConditionalWrapper, "ConditionalWrapper", "/home/vsts/work/1/s/src/components/themes/themeWrapper.js");
  reactHotLoader.register(themeWrapper, "themeWrapper", "/home/vsts/work/1/s/src/components/themes/themeWrapper.js");
  reactHotLoader.register(_default, "default", "/home/vsts/work/1/s/src/components/themes/themeWrapper.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();